import React, {Component, Fragment} from 'react';
import {Button, Col, FormGroup, Label} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';

class FormDatePicker extends Component {
	constructor(props) {
		super(props);
		this.state = {

		};

		this.formatAndSave = this.formatAndSave.bind(this);
	}

	formatAndSave(nextDate, usefulID) {
		if (nextDate === '') {
			return this.props.triggerFormDateChange(usefulID, nextDate);
		}
		nextDate.setHours(12);

		let fmtDate = moment(nextDate);
		fmtDate = moment(fmtDate).format('ddd MMM DD HH:mm:ss UTC YYYY');

		return this.props.triggerFormDateChange(usefulID, fmtDate);
	}

	render() {
		let usefulID = `${this.props.parentID}-${this.props.label}`;

		let displayLabel = this.props.humanLabel;
		if (this.props.dbView) {
			displayLabel = `${this.props.parentID.split('-')[0]}.${this.props.label}`;
		}

		// if passed an empty string, Date.parse helpfully returns NaN.
		// We detect this and pass null to the datepicker because that it's way of representing a blank date.
		let displayDate = Date.parse(this.props.date);
		if (isNaN(displayDate)) {
			displayDate = null;
		}

		if (this.props.table) {
			return (
				<Col xs={this.props.colsize}>
					<div className="table-date-container">
						<DatePicker
							className="rounded-0 dateinput textinput form-control"
							selected={displayDate}
							onChange={(nextDate) => {
								return this.formatAndSave(nextDate, usefulID);
							}}
							withPortal
							showYearDropdown
							scrollableYearDropdown
							yearDropdownItemNumber={15}
						/>
						<Button className="date-clear-btn-mini" onClick={() => {
							return this.formatAndSave('', usefulID);
						}}>x</Button>
					</div>
				</Col>
			);
		}

		return (
			<Fragment>
				<Col xs={this.props.colsize} className={this.props.className}>
					<FormGroup>
						<Label
							className="simpleLabel"
							for={`${this.props.parentID}-${this.props.label}`}
						>
							{displayLabel}
						</Label>
						<div className="date-container">
							<DatePicker
								className="rounded-0 dateinput textinput form-control"
								selected={displayDate}
								onChange={(nextDate) => {
									return this.formatAndSave(nextDate, usefulID);
								}}
							/>
							<Button className="date-clear-btn" onClick={() => {
								return this.formatAndSave('', usefulID);
							}}>x</Button>
						</div>
					</FormGroup>
				</Col>
			</Fragment>
		);
	}

}

export default FormDatePicker;




// WEBPACK FOOTER //
// ./src/components/FormDatePicker.js